// import React from 'react';
import s from './Aside.module.scss';
import InstagramEmbedBlog from "../../components/InstagramEmbedBlog/InstagramEmbedBlog";
import React, {useEffect, useState} from 'react';
import axios from "axios";

export const Aside = () => {
    const API_URL = process.env.REACT_APP_API_LOCAL_URL;
    const [campaigns, setCampaigns] = useState([]);
    const [news, setNews] = useState([]);

    useEffect(() => {
        fetchCampaigns();
        fetchNews();
    }, []);

    const fetchCampaigns = async () => {
        try {
            const res = await axios.get(`${API_URL}campaigns-all`);
            setCampaigns(res.data.data || res.data);
        } catch (err) {
            console.error(err);
        }
    };
    const fetchNews = async () => {
        try {
            const res = await axios.get(`${API_URL}news-all`);
            setNews(res.data.data || res.data);
        } catch (err) {
            console.error(err);
        }
    };
    return (
        <aside className={s.aside}>
            <div className={s.news}>
                <div id="render_shortcode_adventure_tours-16" className={s.widget}><h3
                    class="widget__title">キャンペーン</h3>
                    <ul>
                        {campaigns.map((campaign) => (
                            <li key={campaign.id} className={s.category}>
                                <a href={`/campaign/${campaign.slug}`}>
                                    {campaign.name}
                                </a>
                            </li>
                        ))}

                    </ul>
                </div>
            </div>
            <div className={s.news}>
                <div id="render_shortcode_adventure_tours-16" className={s.widget}><h3
                    class="widget__title">News</h3>
                    <ul>
                        {news.map((item) => (
                            <li key={item.id} className={s.category}>
                                <a href={`/news/${item.slug}`}>
                                    {item.newsTitle}
                                </a>
                            </li>
                        ))}

                    </ul>
                </div>
            </div>

        </aside>
    )
}
